<div class="tablist-group">
  @for (tab of tabList; track $index) {
    <div class="tab" [class.active]="activeTabId === tab?.id" (click)="setActiveTab(tab)">
      @if (tabList.length > 1 && !readonly) {
        <i class="pi pi-times rm-btn" (click)="removeTab($index, tab)"></i>
      }
      <span>{{ tab?.label }}</span>
    </div>
  }
</div>
